import React, { useContext } from 'react';
import { Wrapper, PageLead, Button, EmptyCartIcon, withLocalization, ContentLoader } from '@adac-mp/components';
import {
	OfferContext,
	countryUrlMap,
	getEmptyCartCollection,
	setRouteLangParam,
	getLabelValue,
	getUrlBasePath,
} from '@adac-mp/shared';
import { useViewport } from '@adac-mp/components/src/hooks/useViewport';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { useFlowId } from '@adac-mp/components/src/hooks/useFlowId';

const EmptyCartPage = () => {
	const navigate = useNavigate();
	const flowId = useFlowId();
	const { viewport } = useViewport();
	const { lang } = useParams();
	const { labels } = useContext(OfferContext);
	const { error, data, loading } = useQuery(getEmptyCartCollection, {
		variables: { lang: lang || 'de' },
	});

	const emptyCartLabels = !error ? data?.vignettenFehlerseitenCollection.items[0] : undefined;

	const renderButtonGroup = () => (
		<div className="w-full sticky flex flex-col gap-1.5 justify-center bg-white p-1.5 bottom-0 md:static md:flex-row md:p-0 md:gap-4">
			{/* extact path needs to be defined */}
			<Button
				fullWidth
				href="https://www.adac.de/fahrzeugwelt/maut-vignette"
				variant="secondary"
				className="md:max-w-[262px]">
				{getLabelValue('mp.backToStart', labels) || 'Zurück zur Startseite'}
			</Button>
			{/* needs to be adapted if other products have a cart */}
			<Button
				fullWidth
				className="md:max-w-[262px]"
				onClick={() => {
					if (flowId !== null) {
						navigate(getUrlBasePath(`/${countryUrlMap[flowId]}/configure${setRouteLangParam(lang)}`));
					} else {
						window.location.href = 'https://www.adac.de/fahrzeugwelt/maut-vignette';
					}
				}}>
				{emptyCartLabels?.buyProductLabel || 'Produkt kaufen'}
			</Button>
		</div>
	);
	return (
		<>
			{loading ? (
				<ContentLoader isLoading hasPortal={false} />
			) : (
				<>
					<Wrapper className="bg-white items-center min-h-[calc(100vh_-_56px)] sm:min-h-[calc(100vh_-_98px)]">
						<PageLead
							icon={<EmptyCartIcon />}
							headline={emptyCartLabels?.emptyCartTitel || 'Momentan ist ihr Warenkorb leer.'}
							description={emptyCartLabels?.emptyCartText || 'Bitte wählen Sie Ihren nächsten Schritt.'}
						/>
						{viewport === 'desktop' && renderButtonGroup()}
					</Wrapper>
					{viewport === 'mobile' && renderButtonGroup()}
				</>
			)}
		</>
	);
};

export const EmptyCart = withLocalization(EmptyCartPage);
